import { type RouterOutput, trpc } from "~/libs/trpc.lib";
import { boardInvitations$ } from "./board-invitations.crud";
import type { BoardInvitation } from "./board-invitations.types";

export type InviteToBoardResult = RouterOutput["boardInvitations"]["create"];

/**
 * Sends a board invitation. Wraps `boardInvitations.create.mutate` so
 * callers pass the natural `(boardId, email)` pair instead of the
 * synthetic store-row shape required by the CRUD `create` callback,
 * which is why the store omits that callback. The returned invitation row is
 * written into `boardInvitations$` directly so the local share dialog
 * updates synchronously while the org channel broadcast handles other
 * subscribers; callers also receive create-vs-resend delivery metadata.
 */
export const inviteToBoard = async (boardId: string, email: string) => {
  const result = await trpc.boardInvitations.create.mutate({
    boardId,
    email,
  });
  if (result?.invitation) {
    boardInvitations$[result.invitation.id].set(
      result.invitation as BoardInvitation,
    );
  }
  return result;
};
